import Plugin from "@ckeditor/ckeditor5-core/src/plugin";

export default class AddSpecialCharacters extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;

    this.editor.plugins.get('SpecialCharacters').addItems('Mathematical', [
      { title: 'zero', character: '0' },
      { title: 'one', character: '1' },
      { title: 'two', character: '2' },
      { title: 'three', character: '3' },
      { title: 'four', character: '4' },
      { title: 'five', character: '5' },
      { title: 'six', character: '6' },
      { title: 'seven', character: '7' },
      { title: 'eight', character: '8' },
      { title: 'nine', character: '9' },
      { title: 'plus sign', character: '+' },
      { title: 'hyphen', character: '-' },
      { title: 'slash', character: '/' },
      { title: 'single quote Mark', character: "'" },
      { title: 'colon', character: ':' },
      { title: 'semicolon', character: ';' },
      { title: 'equal sign', character: '=' },
      { title: 'less than', character: '<' },
      { title: 'dot', character: '.' },
      { title: 'greater than', character: '>' },
      { title: 'question Mark', character: '?' },
      { title: 'percentage', character: '%' },
      { title: 'open bracket', character: '[' },
      { title: 'close bracket', character: ']' },
      { title: 'Open parenthesis', character: '(' },
      { title: 'close parenthesis', character: ')' },
      { title: 'Circumflex,caret', character: '^' },
      { title: 'Open brace', character: '{' },
      { title: 'close brace', character: '}' },
      { title: 'Vertical bar, pipe', character: '|' },
      { title: 'five-sixths', character: '⅚' },
      { title: 'one-sixth', character: '⅙' },
      { title: 'two-thirds', character: '⅔' },
      { title: 'one-third', character: '⅓' },
      { title: 'seven-eighths', character: '⅞' },
      { title: 'five-eighths', character: '⅝' },
      { title: 'three-eighths', character: '⅜' },
      { title: 'one-eighths', character: '⅛' },
      { title: '&alpha;', character: 'α' },
      { title: '&beta', character: 'β' },
      { title: '&gamaa;', character: 'γ' },
      { title: 'super script one',character:'¹' },
      { title: 'super script two', character:'²' },
      { title: 'super script three', character:'³' },
      { title: 'pilcrow sign', character:'¶' },
      { title: 'cedilla',character:'¸' },
      { title: 'single low-9 quotation', character: '‚' },
      { title: 'single high-9 quotation', character: '‛' },
      { title: 'double low-9 quotation', character: '„' },
      { title: 'black right pointing pointer', character: '►' },
      { title: 'almost equal to', character: '≈' },
      { title: 'black diamond suite', character: '♦' },
      { title: 'left right double arrow', character: '⇔' },
      { title: 'bullet', character: '•' },
      { title: 'check mark', character: '✓' },
      { title: 'box with check', character: '☑' },
    ]);

    this.editor.plugins.get('SpecialCharacters').addItems('Text', [
      { title: 'Exclamation point', character: '!' },
      { title: 'at sign', character: ' @' },
      { title: 'ampersand', character: '&' },
      { title: 'Octothorpe', character: '#' },
      { title: 'capital A', character: 'A' },
      { title: 'capital B', character: 'B' },
      { title: 'capital C', character: 'C' },
      { title: 'capital D', character: 'D' },
      { title: 'capital E', character: 'E' },
      { title: 'capital F', character: 'F' },
      { title: 'capital G', character: 'G' },
      { title: 'capital H', character: 'H' },
      { title: 'capital I', character: 'I' },
      { title: 'capital J', character: 'J' },
      { title: 'capital K', character: 'K' },
      { title: 'capital L', character: 'L' },
      { title: 'capital M', character: 'M' },
      { title: 'capital N', character: 'N' },
      { title: 'capital O', character: 'O' },
      { title: 'capital P', character: 'P' },
      { title: 'capital Q', character: 'Q' },
      { title: 'capital R', character: 'R' },
      { title: 'capital S', character: 'S' },
      { title: 'capital T', character: 'T' },
      { title: 'capital U', character: 'U' },
      { title: 'capital V', character: 'V' },
      { title: 'capital W', character: 'W' },
      { title: 'capital X', character: 'X' },
      { title: 'capital Y', character: 'Y' },
      { title: 'capital Z', character: 'Z' },
      { title: 'small a', character: 'a' },
      { title: 'small b', character: 'b' },
      { title: 'small c', character: 'c' },
      { title: 'small d', character: 'd' },
      { title: 'small e', character: 'e' },
      { title: 'small f', character: 'f' },
      { title: 'small g', character: 'g' },
      { title: 'small h', character: 'h' },
      { title: 'small i', character: 'i' },
      { title: 'small j', character: 'j' },
      { title: 'small k', character: 'k' },
      { title: 'small l', character: 'l' },
      { title: 'small m', character: 'm' },
      { title: 'small n', character: 'n' },
      { title: 'small o', character: 'o' },
      { title: 'small p', character: 'p' },
      { title: 'small q', character: 'q' },
      { title: 'small r', character: 'r' },
      { title: 'small s', character: 's' },
      { title: 'small t', character: 't' },
      { title: 'small u', character: 'u' },
      { title: 'small v', character: 'v' },
      { title: 'small w', character: 'w' },
      { title: 'small x', character: 'x' },
      { title: 'small y', character: 'y' },
      { title: 'small z', character: 'z' },
    ]);

    this.editor.plugins.get('SpecialCharacters').addItems('Latin', [
      { title: 'latin small sharp s', character:'ß' },
      { title: 'latin small letter a with grave accent', character:'à' },
      { title: 'latin small letter a with acute accent', character:'á' },
      { title: 'latin small letter a with circumflex', character:'â' },
      { title: 'latin small letter a with tilde', character:'ã' },
      { title: 'latin small letter a with diaersis', character:'ä' },
      { title: 'latin small letter a with ring above', character:'å' },
      { title: 'latin small ae', character:'æ' },
      { title: 'latin small letter c with cedilla', character:'ç' },
      { title: 'latin small letter e with grave accent', character:'è' },
      { title: 'latin small letter e with acute accent', character:'é' },
      { title: 'latin capital letter A with above ring', character: 'Å' },
      { title: 'latin capital letter A with diaersis', character: 'Ä' },
      { title: 'latin capital letter A with tilde', character: 'Ã' },
      { title: 'latin capital letter A with circumflex', character: 'Â' },
      { title: 'latin capital letter A with acute accent', character: 'Á' },
      { title: 'latin capital letter A with grave accent', character: 'À' },
      { title: 'latin capital letter E with grave accent', character: 'È' },
      { title: 'latin capital letter E with acute accent', character: 'É' },
      { title: 'latin capital letter E with circumflex', character: 'Ê' },
      { title: 'latin capital letter E with diaeresis', character: 'Ë' },
      { title: 'latin capital letter I with grave accent', character: 'Ì' },
      { title: 'latin capital letter I with acute accent', character: 'Í' },
      { title: 'latin capital letter I with circumflex', character: 'Î' },
      { title: 'latin capital letter I with diaeresis', character: 'Ï' },
      { title: 'latin capital Eth', character: 'Ð' },
      { title: 'latin capital letter N with tilde', character: 'Ñ' },
      { title: 'latin capital letter O with grave accent', character: 'Ò' },
      { title: 'latin capital letter O with acute accent', character: 'Ó' },
      { title: 'latin capital letter O with circumflex', character: 'Ô' },
      { title: 'latin capital letter O with tilde', character: 'Ô' },
      { title: 'latin capital letter O with diaeresis', character: 'Ö' },
      { title: 'Multiplication Sign', character: '×' },
      { title: "small 'e' with breve", character: 'ĕ' },
      { title: "capital 'E' with breve", character: 'Ĕ' },
      { title: "small 'a' with breve", character: 'ă' },
      { title: "capital 'A' with breve", character: 'Ă' },
      { title: 'latin small u with circumflex', character: 'û' },
      { title: 'latin small u with diaeresis', character: 'ü' },
      { title: 'latin small y with acute accent', character: 'ý' },
      { title: 'latin small letter thorn', character: 'þ' },
      { title: 'latin small letter y with diaeresis', character: 'ÿ' },
      { title: 'latin capital ligature OE', character: 'Œ' },
      { title: 'latin small ligature oe', character: 'œ' },
      { title: 'latin small letter u with acute accent ', character: 'ú' },
      { title: 'latin small letter u with grave accent', character: 'ù' },
      { title: 'latin small letter o with stroke', character: 'ø' },
      { title: 'latin small letter o with diaeresis ', character: 'ö' },
      { title: 'latin small letter o with tilde', character: 'õ' },
      { title: 'latin small letter o with circumflex', character: 'ô' },
      { title: 'latin small letter o with acute accent', character: 'ó' },
      { title: 'latin small letter o with grave accent', character: 'ò' },
      { title: 'latin small lectter n with tilde', character: 'ñ' },
      { title: 'latin small letter eth', character: 'ð' },
      { title: 'latin small letter i with diaeresis', character: 'ï' },
      { title: 'latin small letter i with circumflex', character: 'î' },
      { title: 'latin small letter i with acute accent', character: 'í' },
      { title: 'latin small letter i with grave accent', character: 'ì' },
      { title: 'latin small letter e with diaeresis', character: 'ë' },
      { title: 'latin small letter e with circumflex', character: 'ê' },
      { title: 'latin capital letter U with grace accent', character: 'Ù' },
      { title: 'latin capital C with cedilla', character: 'Ç' },
      { title: 'latin capital letter AE', character: 'Æ' },
      { title: 'inverted question mark', character: '¿' },
      { title: "latin capital letter 'O' with stroke", character: 'Ø' },
      { title: "small 'o' with breve", character: 'ŏ' },
      { title: "capital 'O' with breve", character: 'Ŏ' },
      { title: "small 'i' with breve", character: 'ĭ' },
      { title: "capital 'I' with breve", character: 'Ĭ' },
      { title: "small 'u' with breve ", character: 'ŭ' },
      { title: "capital 'U' with breve", character: 'Ŭ' },
    ]);
  }
}
